/**
 * IMAGE-CROP-UX-A1 — narrow avatar-crop eligibility classification.
 * Does not change IMAGE_ACCEPT / CHAT_IMAGE_ACCEPT picker contracts.
 */

import { extensionOf, isHeicLike } from "../imageFileContract";

const PROFILE_CROP_EXTS = new Set([".jpg", ".jpeg", ".png"]);
const PROFILE_CROP_MIMES = new Set([
  "image/jpeg",
  "image/jpg",
  "image/pjpeg",
  "image/png",
]);

const CHAT_LOGO_CROP_EXTS = new Set([
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".gif",
]);
const CHAT_LOGO_CROP_MIMES = new Set([
  "image/jpeg",
  "image/jpg",
  "image/pjpeg",
  "image/png",
  "image/webp",
  "image/gif",
]);

function matchesMimeOrExt(file, mimeSet, extSet) {
  if (!file) return false;
  const mime = (file.type || "").toLowerCase();
  const ext = extensionOf(file.name);
  if (mime && mimeSet.has(mime)) return true;
  if ((!mime || mime === "application/octet-stream") && extSet.has(ext)) {
    return true;
  }
  if (!mime && extSet.has(ext)) return true;
  return false;
}

/** Profile crop-eligible: JPEG/JPG/PNG (not HEIC/HEIF). */
export function isProfileCropEligible(file) {
  if (!file || isHeicLike(file)) return false;
  return matchesMimeOrExt(file, PROFILE_CROP_MIMES, PROFILE_CROP_EXTS);
}

/**
 * Chat-logo crop-eligible when browser-decodable formats:
 * JPEG/JPG/PNG/WebP/GIF (not HEIC/HEIF).
 */
export function isChatLogoCropEligible(file) {
  if (!file || isHeicLike(file)) return false;
  return matchesMimeOrExt(file, CHAT_LOGO_CROP_MIMES, CHAT_LOGO_CROP_EXTS);
}

export const HEIC_NO_LOCAL_CROP_MESSAGE =
  "HEIC/HEIF потребує підготовки перед обрізанням. Підтвердіть безпечну серверну підготовку попереднього перегляду, якщо локальне декодування недоступне.";

export const CROP_DECODE_ERROR_MESSAGE =
  "Не вдалося прочитати це зображення. Оберіть інший файл.";

export const CROP_EXPORT_ERROR_MESSAGE =
  "Не вдалося створити обрізане зображення. Спробуйте ще раз.";

export const CROP_DIMENSION_ERROR_MESSAGE = "Файл має некоректні розміри.";
